import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-600 via-teal-700 to-emerald-700 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Column 1 - Product */}
          <div>
            <h4 className="text-xs font-bold tracking-widest mb-4 uppercase">PRODUCT</h4>
            <div className="h-px bg-white/30 mb-6"></div>
            <ul className="space-y-3">
              <li>
                <a
                  href="/#features"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="/#pricing"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="/#how-it-works"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  How It Works
                </a>
              </li>
              <li>
                <a
                  href="/#testimonials"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Testimonials
                </a>
              </li>
              <li>
                <Link
                  to="/demo"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Watch Demo
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 2 - Company */}
          <div>
            <h4 className="text-xs font-bold tracking-widest mb-4 uppercase">COMPANY</h4>
            <div className="h-px bg-white/30 mb-6"></div>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Legal */}
          <div>
            <h4 className="text-xs font-bold tracking-widest mb-4 uppercase">LEGAL</h4>
            <div className="h-px bg-white/30 mb-6"></div>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/sms-opt-in"
                  className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  SMS Opt-In &amp; Compliance
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Branding & Social */}
          <div>
            <img
              src="https://static.readdy.ai/image/e31f2f4702878072217cd119276d8644/5b56961b60c36d4ff2ff86c82d13a1e4.png"
              alt="AI Receptionist Logo"
              className="h-10 w-auto mb-6"
            />
            <div className="grid grid-cols-2 gap-3">
              <a
                href="#"
                className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer"
                rel="nofollow"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer"
                rel="nofollow"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/70">
            &copy; 2025 AI Receptionist. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link
              to="/privacy"
              className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
            >
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
